<template>
  <div class="func-box">
    <!-- 左侧工具栏 -->
    <div class="left">
      <el-tooltip class="item" effect="dark" content="添加矩形" placement="top">
        <img class="func-img" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/juxing.png"
          @click="addRect" />
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="添加六边形" placement="top">
        <img class="func-img" src="https://bookor-formal.oss-cn-beijing.aliyuncs.com/assets/img/six.png"
          @click="addHexagon" />
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="添加圆形" placement="top">
        <img class="func-img" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/cir.png"
          @click="addCir" />
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="添加文字" placement="top">
        <img class="func-img" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/text.png" 
          @click="addText">
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="添加图片" placement="top">
        <i class="el-icon-picture-outline" @click="addPhoto"></i>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="创建组合" placement="top">
        <i class="el-icon-connection" @click="$emit('group-selected-nodes')" 
          :class="!canGroup ? 'disable' : ''"></i>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="取消组合" placement="top">
        <i class="el-icon-remove-outline" @click="$emit('ungroup-selected-nodes')" 
          :class="!canUngroup ? 'disable' : ''"></i>
      </el-tooltip>
      <input type="file" ref="imageFile" accept="image/*" id="file" @change="handleFileChange"
        style="display: none" />
      <el-tooltip class="item" effect="dark" content="撤销" placement="top">
        <i class="el-icon-arrow-left" :class="!canUndo ? 'disable' : ''" @click="undo"></i>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="重做" placement="top">
        <i class="el-icon-arrow-right" :class="!canRedo ? 'disable' : ''" @click="redo"></i>
      </el-tooltip>
      
      <!-- 进入气泡图按钮 -->
      <el-tooltip class="item" effect="dark" content="进入气泡图" placement="top">
        <i class="el-icon-share bubble-btn" @click="jumpToBubble"></i>
      </el-tooltip>
    </div>

    <!-- 中间标题输入框 -->
    <div class="center">
      <el-input placeholder="请输入白板标题" class="title" :value="title" 
        @input="$emit('update:title', $event)"></el-input>
    </div>

    <!-- 右侧操作按钮 -->
    <div class="right">
      <el-popover placement="top-start" title="帮助" width="400" trigger="hover">
        <i slot="reference" class="el-icon-upload" @click="$emit('upload-file')"></i>
        <div>
          <p>
            ●
            导入功能：本地上传txt文档，将创建一个白板图；如果已经打开的白板图上点击导入，那么新导入的内容将被合并在一起。
          </p>
          <p>● 图形代号："1-" 代表圆形，"2-"代表方形，</p>
          <p>
            ●
            txt文档格式：【1-元素名称】子元素内容；句号为句子的分割符号。例如：【1-元素】子元素a。子元素b....。
          </p>
          <p></p>
          <p>● 空一行，可区分不同类别</p>
        </div>
      </el-popover>
      <input type="file" accept=".txt" ref="textFile" id="textFile" style="display: none"
        @change="handleFileSelect" />
      <el-popover placement="top-start" title="快捷键" width="200" trigger="hover">
        <i class="el-icon-help" slot="reference"></i>
        <div>
          <p>1. Del 删除</p>
          <p>2. Ctrl + C 复制</p>
          <p>3. Ctrl + V 粘贴</p>
          <p>4. Ctrl + X 删除</p>
          <p>5. Ctrl + Z 撤销</p>
          <p>6. Ctrl + Y 重做</p>
          <p>7. Ctrl + G 组合</p>
          <p>8. Ctrl + Shift + G 取消组合</p>
          <p>9. 滚轮缩放</p>
          <p>10. 双击空白处切换拖拽</p>
        </div>
      </el-popover>
      <el-dropdown @command="handleShareCommand">
        <i class="el-icon-share"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="0">好友分享</el-dropdown-item>
          <el-dropdown-item :command="1">站外分享</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <p id="copyBtn" ref="copyBtn" style="display: none" :data-clipboard-text="copyText"></p>
      <el-tooltip class="item" effect="dark" content="下载" placement="top">
        <i class="el-icon-download" @click="$emit('download-image')"></i>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="保存" placement="top">
        <img class="save-img" src="https://bookor-application.oss-cn-beijing.aliyuncs.com/save.png" 
          @click="save" />
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { rectNode, cirNode, hexagonNode, textNode } from './util'

export default {
  name: 'DraftToolbar',
  props: {
    title: {
      type: String,
      default: ''
    },
    canGroup: {
      type: Boolean,
      default: false
    },
    canUngroup: {
      type: Boolean,
      default: false
    },
    canUndo: {
      type: Boolean,
      default: false
    },
    canRedo: {
      type: Boolean,
      default: false
    },
    copyText: {
      type: String,
      default: ''
    },
    // 新增 props，用于接收 graph 和 history 实例
    graph: {
      type: [Object, null],
      default: null,
      validator: () => true // 允许任何类型，包括 X6.Graph 实例
    },
    history: {
      type: [Object, null],
      default: null,
      validator: () => true // 允许任何类型
    },
    draftId: {
      type: [String, Number],
      default: null
    }
  },
  emits: [
    'handle-command',
    'add-hexagon',
    'add-photo',
    'group-selected-nodes',
    'ungroup-selected-nodes',
    'undo',
    'redo',
    'update:title',
    'upload-file',
    'handle-file-select',
    'to-share',
    'download-image',
    'save',
    'handle-file-change',
    // 新增事件
    'add-node',
    'save-draft',
    'jump-to-bubble'
  ],
  methods: {
    // 原有方法
    handleFileSelect(event) {
      this.$emit('handle-file-select', event)
    },
    handleShareCommand(command) {
      this.$emit('to-share', command)
    },
    // 暴露方法给父组件调用
    triggerImageUpload() {
      this.$refs.imageFile.click()
    },
    triggerTextUpload() {
      this.$refs.textFile.click()
    },

    // 从 draft.vue 移过来的方法
    addRect() {
      const rect = rectNode()
      if (this.graph) {
        this.graph.addNode(rect)
      } else {
        this.$emit('add-node', rect)
      }
    },
    
    addCir() {
      const cir = cirNode()
      if (this.graph) {
        this.graph.addNode(cir)
      } else {
        this.$emit('add-node', cir)
      }
    },
    
    addHexagon() {
      const node = hexagonNode()
      if (this.graph) {
        this.graph.addNode(node)
      } else {
        this.$emit('add-node', node)
      }
    },
    
    addText() {
      const text = textNode()
      if (this.graph) {
        this.graph.addNode(text)
      } else {
        this.$emit('add-node', text)
      }
    },
    
    addPhoto() {
      this.triggerImageUpload()
    },
    
    handleCommand(command) {
      if (command === 'rectangle') {
        this.addRect()
      } else if (command === 'six') {
        this.addHexagon()
      } else if (command === 'text') {
        this.addText()
      } else {
        this.addCir()
      }
    },
    
    undo() {
      if (this.history) {
        this.history.undo()
      } else {
        this.$emit('undo')
      }
    },
    
    redo() {
      if (this.history) {
        this.history.redo()
      } else {
        this.$emit('redo')
      }
    },
    
    jumpToBubble() {
      this.$emit('jump-to-bubble')
    },
    
    save() {
      if (!this.title) {
        return this.$message({
          message: '标题不能为空',
          type: 'error',
          duration: 1000
        })
      }
      
      if (this.graph) {
        const json = this.graph.toJSON()
        if (!json.cells.length) {
          return this.$message({
            message: '白板内容为空',
            type: 'error',
            duration: 1000
          })
        }
        this.$emit('save-draft', json)
      } else {
        this.$emit('save')
      }
    },
    
    handleFileChange(event) {
      const file = event.target.files[0]
      if (!file) return
      
      const imageUrl = URL.createObjectURL(file)
      const image = new Image()
      image.src = imageUrl
      image.onload = () => {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        canvas.width = image.width
        canvas.height = image.height
        context.drawImage(image, 0, 0)
        const base64Data = canvas.toDataURL('image/webp', 0.6)
        let width = image.width
        let height = image.height
        
        // 限制图片大小
        if (width > 200) {
          height = (height * 200) / width
          width = 200
        }
        if (height > 200) {
          width = (width * 200) / height
          height = 200
        }
        
        const imageNode = {
          shape: 'image',
          x: 100,
          y: 100,
          width: width,
          height: height,
          imageUrl: base64Data,
          attrs: {
            image: {
              'xlink:href': base64Data
            }
          }
        }
        
        if (this.graph) {
          this.graph.addNode(imageNode)
        } else {
          this.$emit('add-node', imageNode)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.func-box {
  width: calc(100% - 10px);
  height: 30px;
  box-shadow: 0 2px 5px 1px rgba(52, 51, 53, 0.16);
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;

  .el-icon-picture-outline {
    position: relative;
    top: -2px;
  }

  .func-img {
    height: 20px;
    margin-right: 10px;
    cursor: pointer;
  }

  i {
    font-size: 22px;
    margin-right: 10px;
    cursor: pointer;
  }

  .el-icon-upload {
    font-size: 24px;
    margin-right: 16px;
  }

  .disable {
    color: #ccc;
  }

  .center .title {
    border: none;
    width: 250px;
  }

  .center input {
    border: none;
  }
}

.save-img {
  height: 22px;
  margin-right: 10px;
  cursor: pointer;
}

:deep(.func-box .el-input__inner) {
  height: 30px;
}

/* 气泡图按钮样式 */
.bubble-btn {
  color: #409EFF;
  font-weight: bold;
}

.bubble-btn:hover {
  color: #66B1FF;
  transform: scale(1.1);
  transition: all 0.2s ease;
}
</style>
